function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7031 0.75H3.57812C3.475 0.75 3.39062 0.834375 3.39062 0.9375V2.4375C3.39062 2.54062 3.475 2.625 3.57812 2.625H7.825L4.16875 15.375H0.367188C0.264062 15.375 0.179688 15.4594 0.179688 15.5625V17.0625C0.179688 17.1656 0.264062 17.25 0.367188 17.25H10.4922C10.5953 17.25 10.6797 17.1656 10.6797 17.0625V15.5625C10.6797 15.4594 10.5953 15.375 10.4922 15.375H6.11875L9.775 2.625H13.7031C13.8062 2.625 13.8906 2.54062 13.8906 2.4375V0.9375C13.8906 0.834375 13.8062 0.75 13.7031 0.75Z",
  fill: "currentColor"
});

var SvgIcItalic = function SvgIcItalic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcItalic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_italic.9b85495f.svg";
export { ForwardRef as ReactComponent };